module.exports = __webpack_public_path__ + "static/award-topshareware-6ff22b13e61fed80e2acb7dd153308f2.png";